import axiosInstance from '@helpers/Axios';
import { BatchStatus } from '@interfaces/BatchStatus';
import { logError } from '@utils/axios/ErrorLogging';
import ProfileContentVO from '@interfaces/contents/ProfileContentVO';
import QuestionDetailsVO from '@interfaces/contents/QuestionDetailsVO';

/** Response shape from `mapQuestionnairePackages` batch status polling */
export type MapQuestionnairePackagesResult = {
  [BatchStatus.COMPLETED]?: Record<string, unknown>;
  [BatchStatus.ERROR]?: unknown[];
};

const errorLogger = (e: unknown, method: string) => {
  logError(e, 'QuestionnaireService.ts', method);
};

export const mapQuestionnairePackages = async (
  questionnaireIds: string[],
  addlDetails: { [key: string]: { [key: string]: string } },
  isPublicUser: boolean,
  companyId: string,
  callBackFunc: (response: MapQuestionnairePackagesResult) => void,
  onFailed: () => void
) => {
  try {
    const postBody = { ids: questionnaireIds, addlDetails };
    const url: string = `guest_v3/${isPublicUser ? `public/${companyId}/` : ''}profiles/questionnaires/map-packages${isPublicUser ? '?isPublicUser=true' : ''}`;
    const response = await axiosInstance().post(url, postBody);
    if (response && response.status === 200 && response.data) {
      callBackFunc(response.data as MapQuestionnairePackagesResult);
    } else {
      onFailed();
    }
  } catch (e) {
    onFailed();
    errorLogger(e, 'mapQuestionnairePackages');
  }
};

export const getQuestions = async (
  contentVO: ProfileContentVO,
  questionnaireSectionId: string,
  isPublicUser: boolean,
  companyId: string
): Promise<QuestionDetailsVO[] | undefined> => {
  try {
    const sourceDataUrl = `${contentVO.profileId}/sections/${contentVO.sectionId}/content/${contentVO.id}/get-section-questions${isPublicUser ? '?isPublicUser=true' : ''}`;
    const url: string = `guest_v3/${isPublicUser ? `public/${companyId}/` : ''}profiles/${sourceDataUrl}`;
    const response = await axiosInstance().get(url, { params: { questionnaireId: contentVO.sourceRefId, questionnaireSectionId } });
    return response.data as QuestionDetailsVO[];
  } catch (e) {
    errorLogger(e, 'getQuestions');
    return undefined;
  }
};
